import React, { Component} from 'react'
import { connect } from 'react-redux'
import { isFetching } from 'utils/redux/fetching'
import SingleCurrency from 'components/SingleCurrency'
import { fetchRates } from 'redux/actions/rates'
import { fetchCryptoRates } from 'redux/actions/cryptoRates'
import Loader from 'components/Loader'

class SingleCurrencyContainer extends Component {
	componentWillMount () {
		const { dispatch, mode } = this.props
		if (mode === 'monetary') {
			dispatch(fetchRates())
		}
		else {
			dispatch(fetchCryptoRates())
		}
	}
	render () {
		if(this.props.isFetching) return <Loader />
		return <SingleCurrency {...this.props} />
	}
}

const mapStateToProps = (state, props) => {
	const { rates, cryptoRates } = state
	const { mode, currencyParam } = props

	if (mode === 'monetary' && isFetching([rates])) return { isFetching: true }
	if (mode === 'crypto' && isFetching([cryptoRates])) return { isFetching: true }

	return {
		currencyRate: mode === 'monetary' ? rates.data.find( r =>  r.abbreviature === currencyParam) : cryptoRates.data.find(r =>  r.abbreviature === currencyParam)
	}
}

export default connect(mapStateToProps)(SingleCurrencyContainer)
